export default __webpack_public_path__ + "c19a25c5a98720a9b030464e996e59cb.png";